import * as Sentry from "@sentry/react";
import { classifyPdfPreviewError } from "@compass/shared/utils/pdfPreviewErrors";

/**
 * Report a PDF preview failure: a breadcrumb for an unsupported viewer, a bad
 * PDF or a network failure, nothing for a cancelled load, and a Sentry
 * exception for anything else — unless the browser is offline, in which case
 * any failure is treated as a network failure (offline is a supported mode).
 * Returns whether the viewer should fall back to the download link.
 */
export function reportPdfPreviewError(error: unknown): boolean {
    const classified = classifyPdfPreviewError(error);
    const kind =
        classified === "unexpected" && typeof navigator !== "undefined" && !navigator.onLine
            ? "network"
            : classified;
    if (kind === "unexpected") {
        Sentry.captureException(error, { tags: { component: "InlinePDFPreview" } });
    } else if (kind !== "cancelled") {
        Sentry.addBreadcrumb({
            category: "pdf-preview",
            level: "info",
            message: `PDF preview ${kind}: ${String(error)}`,
        });
    }
    return kind === "unsupported";
}
